module.exports = __webpack_public_path__ + "assets/img/B3.a3fa081f.jpg";